import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import DemoCredentials from './components/DemoCredentials';

const LoginScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const userType = localStorage.getItem('userType');
    
    if (isAuthenticated === 'true' && userType) {
      // Redirect to appropriate dashboard
      if (userType === 'patient') {
        navigate('/patient-dashboard');
      } else if (userType === 'provider') {
        navigate('/provider-dashboard');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <LoginHeader />
      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {/* Welcome Section */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.07 2.07 0 0 1-2.44-2.44 2.07 2.07 0 0 1-2.44-2.44 2.07 2.07 0 0 1-2.44-2.44A2.5 2.5 0 0 1 2.5 10H12" />
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
            </div>
            
            <h1 className="text-2xl font-semibold text-foreground mb-2">
              Welcome to MycoMind
            </h1>
            <p className="text-muted-foreground text-sm">
              Secure neurological health monitoring platform for patients and healthcare providers
            </p>
          </div>

          {/* Login Form Card */}
          <div className="bg-card border border-border rounded-lg shadow-soft p-6 mb-6">
            <LoginForm />
          </div>

          {/* Demo Credentials */}
          <DemoCredentials />
        </div>
      </main>
      {/* Footer with Security Badges */}
      <footer className="py-8 px-4 border-t border-border bg-card/50">
        <SecurityBadges />
        
        <div className="text-center mt-6">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} MycoMind. All rights reserved. | 
            <button className="ml-1 text-primary hover:text-primary/80 transition-colors duration-150">
              Privacy Policy
            </button> | 
            <button className="ml-1 text-primary hover:text-primary/80 transition-colors duration-150">
              Terms of Service
            </button>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LoginScreen;